import { connect } from 'react-redux';
import { formValueSelector, change as changeFormValue } from 'redux-form';
import { constants } from '@eti/utils';
import { baggagePricePerTraveler } from '../../common/utils/baggageUtils';
import SecondBagCheckBox from '../components/SecondBagCheckBox';
import { CHECK_IN_BAGGAGE, SECOND_BAGGAGE } from '../../../products';
import { setSecondBagValueForTraveler } from '../utils/secondBagUtils';
export const mapDispatchToProps = (dispatch, props) => {
  return {
    setSecondBagValueInCheckedBag: setSecondBagValueForTraveler(dispatch, CHECK_IN_BAGGAGE.name, props),
    setSecondBagValueInSecondBag: setSecondBagValueForTraveler(dispatch, SECOND_BAGGAGE.name, props)
  };
};
const updateIsSelectedSecondBag = (dispatch, form, productName, secondBagId, isSelected) => {
  if (secondBagId) {
    const secondBaggageSelection = `${productName}.isSelectedSecondBaggage-traveler-${secondBagId}`;
    dispatch(changeFormValue(form, secondBaggageSelection, isSelected));
  }
};
const onChange = (dispatch, _ref, shouldApplySelectionToAll) => {
  let {
    firstTravelerSelectionValue,
    form,
    isFirstTraveler,
    productName,
    secondBagTraveler,
    secondBagTravelers,
    orderSecondBag
  } = _ref;
  return checkboxValue => {
    const {
      id: secondBagId
    } = secondBagTraveler || {};
    updateIsSelectedSecondBag(dispatch, form, productName, secondBagId, checkboxValue);
    const {
      setSecondBagValueInCheckedBag,
      setSecondBagValueInSecondBag
    } = mapDispatchToProps(dispatch, {
      orderSecondBag
    });
    const applySecondBagToAllTravelers = () => {
      if (secondBagTravelers && secondBagTravelers !== null && secondBagTravelers !== void 0 && secondBagTravelers.length) {
        secondBagTravelers.forEach((traveler, index) => {
          setSecondBagValueInCheckedBag(form, traveler, checkboxValue);
          setSecondBagValueInSecondBag(form, traveler, checkboxValue);
          if (index > 0) {
            updateIsSelectedSecondBag(dispatch, form, productName, traveler.id, checkboxValue);
          }
        });
      }
    };
    if (isFirstTraveler && shouldApplySelectionToAll) {
      applySecondBagToAllTravelers();
    }
    if (!isFirstTraveler && checkboxValue !== firstTravelerSelectionValue) {
      dispatch(changeFormValue(form, `${productName}.shouldApplySelectionToAll`, false));
    }
    setSecondBagValueInCheckedBag(form, secondBagTraveler, checkboxValue);
    setSecondBagValueInSecondBag(form, secondBagTraveler, checkboxValue);
  };
};
export const mapStateToProps = (state, _ref2) => {
  let {
    form,
    productName,
    orderSecondBag,
    travelerNumber
  } = _ref2;
  const secondBagTravelers = baggagePricePerTraveler(orderSecondBag);
  const travelersWithoutInfantsSecondBag = secondBagTravelers === null || secondBagTravelers === void 0 ? void 0 : secondBagTravelers.filter(trav => trav.ageType !== constants.ageTypes.INFANT);
  const secondBagTraveler = travelersWithoutInfantsSecondBag[travelerNumber];
  const {
    id: travelerId
  } = secondBagTraveler || {};
  const isSelectedSecondBaggage = formValueSelector(form)(state, `${productName}.isSelectedSecondBaggage-traveler-${travelerId}`);
  const shouldApplySelectionToAll = formValueSelector(form)(state, `${productName}.shouldApplySelectionToAll`);
  return {
    isSelectedSecondBaggage,
    shouldApplySelectionToAll
  };
};
export const mergeProps = (_ref3, _ref4, OwnProps) => {
  let {
    shouldApplySelectionToAll,
    isSelectedSecondBaggage
  } = _ref3;
  let {
    dispatch,
    ...dispatchProps
  } = _ref4;
  return {
    onChange: onChange(dispatch, OwnProps, shouldApplySelectionToAll),
    isSelectedSecondBaggage,
    ...dispatchProps,
    ...OwnProps
  };
};
export default connect(mapStateToProps, null, mergeProps)(SecondBagCheckBox);
//# sourceMappingURL=SecondBagCheckBoxContainer.js.map